import { render, staticRenderFns } from "./ModuleViewHeading.vue?vue&type=template&id=1448bc6c&scoped=true&"
import script from "./ModuleViewHeading.vue?vue&type=script&lang=js&"
export * from "./ModuleViewHeading.vue?vue&type=script&lang=js&"
import style0 from "./ModuleViewHeading.vue?vue&type=style&index=0&id=1448bc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448bc6c",
  null
  
)

export default component.exports